import { Injectable } from "@angular/core";

import { ThemeService } from "app/core/theme/theme.service";

import { IconNames } from "app/shared/models/icon-names.interface";
import { IconName } from "app/shared/models/icon-name.type";

import {
  COMMON_ICONS_LIST,
  THEMES_ICONS_LIST,
} from "app/shared/constants/icons-lists/icons-list";

@Injectable({
  providedIn: "root",
})
export class IconService {
  private iconList: IconNames = { ...COMMON_ICONS_LIST };

  constructor(private themeService: ThemeService) {
    this.initIconList();
  }

  public getThemeIcon(iconName: IconName): string {
    return this.iconList[iconName];
  }

  private initIconList(): void {
    const activeTheme: string = this.themeService.getTheme();
    const themeIconsList: Partial<IconNames> = THEMES_ICONS_LIST[activeTheme];

    if (themeIconsList) {
      const activeThemeLabel: string = this.themeService
        .getThemeData()
        .label.toLowerCase();

      for (const icon in themeIconsList) {
        if (themeIconsList.hasOwnProperty(icon)) {
          themeIconsList[icon] =
            themeIconsList[icon].indexOf(activeThemeLabel) === -1
              ? `${activeThemeLabel}/${themeIconsList[icon]}`
              : themeIconsList[icon];
        }
      }

      this.iconList = { ...COMMON_ICONS_LIST, ...themeIconsList };
    }
  }
}
